import styled from 'styled-components';

import { spacing } from '../../styles/theme';

export const Container = styled.div`
  margin: 0px auto;
  max-width: 980px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: ${spacing('8')} 0 ${spacing('2')};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface WrapperFormProps {
  hasBanner: boolean
}

export const WrapperForm = styled.div<WrapperFormProps>`
  display: flex;
  max-width: 375px;
  padding: 16px;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  height: 60px;
  width: 380px;
  border-radius: 12px;
  background-color: #000;
  box-shadow: 0 0 0 0 transparent;
  transition: box-shadow 300ms ease;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: ${(props) => props.hasBanner ? spacing('8') : '170px'};
  margin-top: ${(props) => !props.hasBanner && '106px'};

  &:hover {
    box-shadow: 0 0 0 16px #fff;
  }
`;

export const Form = styled.form`
  display: flex;
  margin-bottom: 0px;
  flex-direction: row;
  align-items: center;
  flex: 1 1 auto;
`;

export const Input = styled.input`
  height: 48px;
  margin-bottom: 0px;
  padding-right: 0px;
  padding-left: 16px;
  flex: 1 1 auto;
  border-style: solid;
  border-width: 0px;
  border-color: #cecece;
  border-radius: 120px;
  background-color: transparent;
  color: #fff;
  font-size: 20px;
  box-sizing: border-box;
  outline: none;
`;

export const Button = styled.button`
  display: flex;
  width: 48px;
  min-height: 48px;
  margin-left: 16px;
  padding: 8px 0px 0px;
  justify-content: center;
  align-items: center;
  border-radius: 120px;
  background-color: #000;
  transition: background-color 300ms ease;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  border: none;
  color: #fff;

  &:hover,
  &:focus {
    background-color: #272727;
  }
`;
